import { useMemo } from 'react';
import { isAndroid, isIOS, isMobile } from 'react-device-detect';

type Platform = 'ios' | 'android' | 'desktop';

function useIsMobileBrowser() {
  const isMobileBrowser = useMemo(() => isMobile, []);
  const platform: Platform = useMemo(() => {
    if (isAndroid) return 'android';
    if (isIOS) return 'ios';
    return 'desktop';
  }, []);

  return { isMobile: isMobileBrowser, platform };
}

export default useIsMobileBrowser;
